import React from 'react';
import styled from '@emotion/styled/macro';
import { MatrixTableHeadProps } from './matrix-table.types';

const MatrixTableHead: React.FC<MatrixTableHeadProps> = ({ thData }) => {
  if (Array.isArray(thData)) {
    return (
      <thead className="table-head" data-testid="table-head">
        <tr>
          {thData.map(column => {
            return (
              <th
                style={{ width: column.columnWidth }}
                key={column.columnLabel}
              >
                {column.columnLabel}
                {column.subLabel ? (
                  <div className="sub-label">{column.subLabel}</div>
                ) : null}
              </th>
            );
          })}
        </tr>
      </thead>
    );
  } else {
    console.warn(
      `MatrixTableHead received invalid arguments - thData: ${thData}`
    );
    return null;
  }
};

const StyledMatrixTableHead = styled(MatrixTableHead)``;

export default StyledMatrixTableHead;
